// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__ObXy6","errorLogs":"EditorFooter_errorLogs__1nWa0"};